<template lang="html">
    <div class="tabs">
        <div class="tabs-navigation py-4 rounded-md flex">
            <ul class="flex space-x-4">
                <li
                    v-for="(tab, index) in tabs"
                    :key="tab.index"
                    @click="selectTab(index)"
                    :class="[(index === selectedIndex) ?
                        'border-cyan-500 text-cyan-600 whitespace-nowrap':
                        'border-transparent hover:text-gray-700 hover:border-gray-300 whitespace-nowrap',
                        'py-3 px-1 border-b font-medium text-sm']"
                >
                    <span class="title cursor-pointer" :class="{'disabled cursor-not-allowed' : !tab.enabled}">{{ tab.title }}</span>
                </li>
            </ul>
            <div class="ml-auto self-center"><slot name="additionalControls"></slot></div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: {
        preSelectedIndex: { type: Number, default: 0 }
    },
    data () {
        return {
            selectedIndex: this.preSelectedIndex, // the index of the selected tab,
            tabs: []         // all of the tabs
        }
    },
    created () {
        this.tabs = this.$children
    },
    mounted () {
        this.selectTab(this.preSelectedIndex)
    },
    methods: {
        getSelectedTab() {
            return this.selectedIndex;
        },
        selectTab (i) {
            if(this.tabs[i] && this.tabs[i].enabled === true) {
                this.selectedIndex = i
                this.$emit('tabSelected', i);
                // loop over all the tabs
                this.tabs.forEach((tab, index) => {
                    tab.isActive = (index === i)
                })
            }
        }
    }
}
</script>
